import React, { useEffect, useState } from "react";

export default function useDragHeader (gridRef: React.RefObject<HTMLDivElement>) {
    const [isHeaderDraging, setIsHeaderDraging] = useState(false);
    useEffect(() => {
        function onDragStart(e: DragEvent) {
          const target = e.target as HTMLDivElement;
         if (target?.getAttribute('role') === 'columnheader') {
            setIsHeaderDraging(true)
         }
        }
        function onDragEnd(e: DragEvent) {
            const target = e.target as HTMLDivElement;
            if (target?.getAttribute('role') === 'columnheader') {
                setIsHeaderDraging(false)
             }
        }
        gridRef.current?.addEventListener('dragstart', onDragStart)
        gridRef.current?.addEventListener('dragend', onDragEnd)
        return () => {
          gridRef.current?.removeEventListener('dragstart', onDragStart);
          gridRef.current?.removeEventListener('dragend', onDragEnd);
        }
      }, []);
      return isHeaderDraging
}